export default __webpack_public_path__ + "static/media/auctux-logo.916fd811.png";